var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('core-toolbar'),_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('main',_vm._b({},'main',_vm.attrs,false),[_c('core-jumbotron'),_c('router-view')],1)]),_c('core-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }